<template>
    <div class="devsignup container-fluid">
        <!-- <div class="row"> -->
        <div class="">
            <router-link to="/">
                <img class="navbar-brand d-sm logo-size my-5" src="/images/logo.png" alt="Kovatek" />
            </router-link>

            <router-link to="/browse" v-if="current < 5" class="skip">
                <a-tooltip placement="leftTop">
                    <template slot="title">
                        <span>You can't bid for jobs if your profile is incomplete</span>
                    </template>
                    <p>Skip all</p>
                </a-tooltip>
            </router-link>

            <div v-else class="logout-container" @click.prevent="logoutHandler">
                <img class="mr-2" height="28" src="@/assets/kovatek/012-logout.svg" />
                <span>Logout</span>
            </div>

            <a-steps v-model="current" type="navigation" :style="stepStyle" v-if="current < 5" class="steps">
                <a-step v-for="n in 5" :key="n" :status="status(n)" :class="current === n ? 'active' : 'show-none'" />
                <span class="total-steps">of 5</span>
            </a-steps>
            <router-view></router-view>
        </div>
        <!-- <div class="col-lg-4 bg-dark h-1000 h-ctrl">
                <h2 class="text-white align-center">Sponsors here</h2>
            </div> -->

        <!-- </div> -->
    </div>
</template>
<script>
export default {
    name: 'devsignup',
    data: () => ({
        current: 1,
        stepStyle: {
            marginBottom: '20px',
            // boxShadow: '0px -1px 0 0 #e8e8e8 inset',
        },
    }),
    methods: {
        status(number) {
            return this.current === number ? 'process' : this.current > number ? 'finish' : 'wait';
        },
        getCurrent() {
            const { path } = this.$route;

            this.current = path.includes('/overview')
                ? 5
                : path.includes('p/devs')
                ? 4
                : path.includes('/experience')
                ? 3
                : path.includes('/speciality')
                ? 2
                : 1;
        },
        logoutHandler() {
            this.$store
                .dispatch('logout')
                .then(() => {
                    this.$router.push('/login');
                })
                .catch(err => {
                    this.error = err.response.data;
                });
        },
    },
    mounted() {
        this.getCurrent();
    },
    updated() {
        this.getCurrent();
    },
};
</script>
<style scoped>
.h-ctrl {
    height: 100vh;
}
.logo-size {
    height: 40px;
    width: 135px;
}

.logout-container {
    position: absolute;
    top: 30px;
    right: 30px;
    cursor: pointer;
}

.total-steps {
    position: relative;
    font-size: 16px;
    display: none;
    bottom: 43px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    left: 39px;
}

.steps {
    width: 50%;
    margin: 0 auto 15px;
}

.steps >>> .ant-steps-item.ant-steps-item-finish .ant-steps-item-icon {
    line-height: 23px;
}

.steps >>> .ant-steps-item-process .ant-steps-item-icon {
    background-color: #06216d;
    border-color: #06216d;
}

.skip {
    position: absolute;
    right: 15px;
    top: 15px;
}

.skip p {
    color: #06216d;
    font-size: 16px;
}

@media screen and (max-width: 767px) {
    .steps >>> .ant-steps-item-process .ant-steps-item-icon {
        margin-right: 0;
    }

    .total-steps {
        display: block;
    }

    .steps >>> .show-none {
        display: none !important;
    }
}
</style>
